import { createApp } from 'vue'
import ESimNotify from '@/components/esim-notify.vue'
import i18n from '@/plugins/vue-i18n' // <== import plugin i18n

let instance = null

function initInstance() {
    if (!instance) {
        const container = document.createElement('div')
        document.body.appendChild(container)

        const app = createApp(ESimNotify)
        app.use(i18n) // <== attach i18n vào app con

        instance = app.mount(container)
    }
}

const NotifyEsim = {
    install(app) {
        initInstance()

        app.config.globalProperties.$notify = function ({ code, message, onClose }) {
            if (instance && typeof instance.show === 'function') {
                instance.show({ code, message, onClose })
            } else {
                console.warn('ESimNotify component is not properly mounted.')
            }
        }
    }
}

export default NotifyEsim